__turbopack_context__.v({
  "hint-wiggle": "i53QjG_hint-wiggle",
  "wiggle": "i53QjG_wiggle",
});
